import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

import { Container, ModalContainer, TextContainer } from './styledComponent';
import InputContentModal from '@commons/Modals/InputContentModal';
import Text, { ENUM_FONTS } from '@commons/Text';

import { MuiNumberInput } from '@commons/MuiNumberInput';

const UpdateProductsWasteRateModalContent = (props) => {
  const { label, placeholder, tooltipText, value, onChange } = props;

  return (
    <ModalContainer>
      <Container>
        <TextContainer>
          <Text font={ENUM_FONTS.TEXT_BIG_HEIGHT_24}>
            {i18next.t('ADMIN.STORES.PRODUCT_MAPPING_TARGET_PRODUCTION_WASTE_RATE_MODAL_CONTENT')}
          </Text>
        </TextContainer>
        <MuiNumberInput
          label={label}
          placeholder={placeholder}
          tooltipText={tooltipText}
          value={value}
          onChange={onChange}
        />
      </Container>
    </ModalContainer>
  );
};

InputContentModal.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  tooltipText: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
};

InputContentModal.defaultProps = {
  type: 'text',
};

export default UpdateProductsWasteRateModalContent;
